/**
 * Status chip. Tones map the palette onto the states from the onboarding
 * wireframes:
 *
 *   live    → ink fill        (settled, the default good state)
 *   waiting → dashed line     (nothing is wrong, we're just not done)
 *   preview → marigold        (accent = "something could become new here")
 *   off     → muted           (present but deliberately inactive)
 *
 * A chip is a statement, never a control — it must not be clickable. Actions
 * live in their own buttons next to it.
 */

import type { ReactNode } from 'react'

export type ChipTone = 'live' | 'waiting' | 'preview' | 'off' | 'plan'

const CHIP_TONES: Record<ChipTone, string> = {
	live: 'bg-ink text-paper border-ink',
	waiting: 'border-dashed border-line-strong text-ink-soft',
	preview: 'border-marigold text-ember',
	off: 'border-line text-ink-mute',
	plan: 'border-dashed border-line-strong text-ink-soft',
}

export function Chip({ tone, children }: { tone: ChipTone; children: ReactNode }) {
	return (
		<span
			className={
				'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 ' +
				'font-sans text-[11px] font-medium whitespace-nowrap ' +
				CHIP_TONES[tone]
			}
		>
			{children}
		</span>
	)
}
